// 灵犀上报函数
import Vue from 'vue';

class CatMethods {
  addError(name: string, val: {}) {
    try {
      window.Owl.addError({
        name,
        msg: name
      }, {
          category: 'jsError',
          level: 'info',
          tags: val
        });
    } catch (error) {
      console.log(error);
    }
  }
}

Vue.prototype.$cat = new CatMethods();

